"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportStatus = exports.ReportPriority = void 0;
var ReportPriority;
(function (ReportPriority) {
    ReportPriority["LOW"] = "low";
    ReportPriority["NORMAL"] = "normal";
})(ReportPriority || (exports.ReportPriority = ReportPriority = {}));
var ReportStatus;
(function (ReportStatus) {
    ReportStatus["PENDING"] = "pending";
    ReportStatus["COMPLETE"] = "complete";
    ReportStatus["ERROR"] = "error";
    ReportStatus["EMPTY"] = "empty";
})(ReportStatus || (exports.ReportStatus = ReportStatus = {}));
